import React, { useState, useEffect, useContext } from "react";
import { Button, Form } from "react-bootstrap";
import { BiArrowBack } from "react-icons/bi";
import { Link, useParams, useNavigate } from "react-router-dom";
import FieldError from "../Common/FieldError";
import * as Joi from "joi-browser";
import {
  haveValue,
  hideLoader,
  showLoader,
  validateJOIFormField,
} from "./../../utils/helpers";
import { State } from "country-state-city";
import { AuthContext } from "../../Context/AuthContext";
import { ThemeContext } from "../../hooks/useThemeContext";
import AuthAction from "../../Actions/auth.service";
import EventAction from "./../../Actions/event.service";

function Address(props) {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    loggedInUserData,
    setLoggedInUserData,
    setIsLoggedIn,
    setIsSidebarVisible,
  } = useContext(AuthContext);
  const { showErrorToast, setHide } = useContext(ThemeContext);
  const [eventData, setEventData] = useState({});

  const [detail, setDetail] = useState({
    email: loggedInUserData.email,
    line1: loggedInUserData?.address?.line1,
    line2: loggedInUserData?.address?.line2,
    country: "IN",
    region: loggedInUserData?.address?.region,
    city: loggedInUserData?.address?.city,
    postcode: loggedInUserData?.address?.postcode,
  });
  const [states, setStates] = useState([]);
  const [errors, setErrors] = useState({});

  const schema = {
    email: Joi.string().email().required().label("Email"),
    line1: Joi.string().min(2).max(1000).required().label("Line 1"),
    line2: Joi.string().min(2).max(1000).required().label("Line 2"),
    country: Joi.string().min(2).required().label("Country"),
    region: Joi.string().min(2).required().label("Region"),
    city: Joi.string().min(2).max(500).required().label("City"),
    postcode: Joi.string().min(2).max(100).required().label("Postcode"),
  };

  useEffect(() => {
    let errors = validateJOIFormField(detail, schema);
    setErrors(errors);
  }, [detail]);

  useEffect(() => {
    setHide(true);
    viewEvent();
    const states = State.getStatesOfCountry(detail.country);
    if (states) {
      setStates(states);
    }
  }, []);

  const handleForm = async (e, name) => {
    const fieldName = name;
    let fieldValue = e;
    setDetail((existingValue) => ({
      ...existingValue,
      [fieldName]: fieldValue,
    }));
  };

  const buttonClickHandler = () => {
    let errors = validateJOIFormField(detail, schema);
    if (errors != null) {
      setErrors(errors);
      return false;
    }
    const data = new FormData();
    data.append("email", detail.email);
    data.append("line1", detail.line1);
    data.append("line2", detail.line2);
    data.append("country", detail.country);
    data.append("region", detail.region);
    data.append("city", detail.city);
    data.append("postcode", detail.postcode);

    showLoader();
    AuthAction.saveAddressDetail(data)
      .then((res) => {
        setLoggedInUserData(res);
        hideLoader();
        handleConfirmOrder();
      })
      .catch((err) => {
        hideLoader();
        if (err?.response?.data?.message) {
          showErrorToast(err?.response?.data?.message);
        }
      });
  };

  const viewEvent = () => {
    showLoader();
    EventAction.viewEvent(id)
      .then((res) => {
        hideLoader();
        setEventData(res);
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.data?.message === "Unauthorized User.") {
          localStorage.removeItem("token");
          setIsLoggedIn(false);
          setIsSidebarVisible(false);
          navigate("/");
        }
      });
  };

  const handleConfirmOrder = async () => {
    if (eventData.isSolo) {

      navigate(`/confirmation/${id}`);
    } else {
      navigate(`/totalcontribution/${id}`);
    }
  };

  console.log("eventData.isSolo",eventData.isSolo);
  return (
    <>
      <div className="homebar TotalContribute p-4 pb-4 d-">
        <div className="crossbar mb-0">
          <Link to={`/organiser/${id}`}>
            <BiArrowBack />
          </Link>
        </div>
        <div className="contri-text">
          <h5>Address</h5>
        </div>
      </div>
      <Form className="mt-3">
        <Form.Group className="formgroup">
          <Form.Label>Email</Form.Label>
          {haveValue(loggedInUserData.email) ? (
            <p className="form-control disabled">{loggedInUserData.email}</p>
          ) : (
            <>
              <Form.Control
                type="email"
                value={detail.email}
                placeholder={"Email ID"}
                onChange={(e) => handleForm(e?.target.value, "email")}
              />
              <FieldError error={errors?.email} />
            </>
          )}
        </Form.Group>
        <Form.Group className="formgroup">
          <Form.Label>Address Line 1</Form.Label>
          <Form.Control
            type="text"
            value={detail.line1}
            placeholder={"Address Line 1"}
            onChange={(e) => handleForm(e?.target.value, "line1")}
          />
          <FieldError error={errors?.line1} />
        </Form.Group>
        <Form.Group className="formgroup">
          <Form.Label>Address Line 2</Form.Label>
          <Form.Control
            type="text"
            value={detail.line2}
            placeholder={"Address Line 2"}
            onChange={(e) => handleForm(e?.target.value, "line2")}
          />
          <FieldError error={errors?.line2} />
        </Form.Group>
        <Form.Group className="formgroup">
          <Form.Label>Country</Form.Label>
          <p className="form-control">India</p>
          <FieldError error={errors?.country} />
        </Form.Group>
        <Form.Group className="formgroup">
          <Form.Label>State</Form.Label>
          <Form.Select
            value={detail.region}
            onChange={(e) => handleForm(e?.target.value, "region")}
          >
            <option value={""}>select</option>
            {states.map((state) => (
              <option value={state.name}>{state.name}</option>
            ))}
          </Form.Select>
          <FieldError error={errors?.region} />
        </Form.Group>
        <Form.Group className="formgroup">
          <Form.Label>City</Form.Label>
          <Form.Control
            type="text"
            value={detail.city}
            placeholder={"city"}
            onChange={(e) => handleForm(e?.target.value, "city")}
          />
          <FieldError error={errors?.city} />
        </Form.Group>
        <Form.Group className="formgroup">
          <Form.Label>Post Code</Form.Label>
          <Form.Control
            type="text"
            value={detail.postcode}
            placeholder={"postcode"}
            onChange={(e) => handleForm(e?.target.value, "postcode")}
          />
          <FieldError error={errors?.postcode} />
        </Form.Group>
        <Button className="btn-pink" type="button" onClick={buttonClickHandler}>
          Save & Continue
        </Button>
      </Form>
    </>
  );
}

export default Address;
